// className= is a JSX attribute (invalid HTML) — unambiguous React marker
// react_components wrapper is emitted by the Boardriders CMS export pipeline
// <[A-Z] catches PascalCase component tags like <Button, <Separator, etc.
const REACT_CONTENT_PATTERN =
    /className=|class\s*=\s*["'][^"']*\breact_components\b[^"']*["']|<[A-Z][A-Za-z0-9]*(?:\s|>)/;

/** Returns true when the content string contains JSX-specific syntax. */
export function isReactContent(content: string): boolean {
    return REACT_CONTENT_PATTERN.test(content);
}
